import { render, staticRenderFns } from "./DecorationLive.vue?vue&type=template&id=f8c5f6ce&scoped=true"
import script from "./DecorationLive.vue?vue&type=script&lang=js"
export * from "./DecorationLive.vue?vue&type=script&lang=js"
import style0 from "./DecorationLive.vue?vue&type=style&index=0&id=f8c5f6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c5f6ce",
  null
  
)

export default component.exports